module.exports = __webpack_public_path__ + "img/news-title.2fc292cc.png";